import {
  POSTS_TYPE_VALUE_ARTICLE,
  POSTS_TYPE_VALUE_PAGE,
} from "@raiden/library/constants/posts";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { getPostSlug } from "./getPostSlug";

/**
 * @param {object} params
 * @param {number} params.postId
 * @param {import("@raiden/library/types/Post").PostType} params.postType
 * @param {import("@raiden/library/types/common/TranslatedField").TranslatedField | null} params.postSlug
 * @param {import("@raiden/library/hooks/useTranslate").Translate} params.translate
 */
export function getPostPath({ postId, postType, postSlug, translate }) {
  if (!postSlug) {
    return undefined;
  }

  switch (postType) {
    case POSTS_TYPE_VALUE_PAGE:
      return generateFrontPath({
        id: "@front.page",
        parameters: { postSlug: getPostSlug({ postId, postSlug, translate }) },
      });

    case POSTS_TYPE_VALUE_ARTICLE:
      return generateFrontPath({
        id: "@front.article",
        parameters: { postSlug: getPostSlug({ postId, postSlug, translate }) },
      });

    default:
      break;
  }

  return undefined;
}
